import { Container } from "../../Container/Container/Container";
import { Text } from "../../Text/Text/Text";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { sanitizeContent, processRichTextContent } from "../../Utility/Utility";
import styles from "./BodySlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BodySlice = function BodySlice(_ref) {
  var headline = _ref.headline,
    body = _ref.body,
    _ref$processJSON = _ref.processJSON,
    processJSON = _ref$processJSON === void 0 ? false : _ref$processJSON;
  var headingTextAdjustment = headline !== null && headline !== void 0 && headline.text && processJSON ? sanitizeContent(headline === null || headline === void 0 ? void 0 : headline.text) : headline === null || headline === void 0 ? void 0 : headline.text;
  var processedBodyText = body && processJSON ? processRichTextContent(body) : body;
  return /*#__PURE__*/_jsxs(Container, {
    children: [headingTextAdjustment && /*#__PURE__*/_jsx(HeadingText, {
      className: styles.title,
      ariaLevel: headline.ariaLevel,
      typog: headline.typog,
      variant: headline.variant,
      align: headline.align,
      children: headingTextAdjustment
    }), /*#__PURE__*/_jsx(Text, {
      className: styles.body,
      typog: "bodycopy",
      richText: true,
      children: processedBodyText
    })]
  });
};